const Title = ({ movieTitle }) => {
  return (
    <>
      <h3 style={{ textAlign: "center" }}>{movieTitle}</h3>
    </>
  );
};

export default Title;
